import { render, staticRenderFns } from "./ConversationsIvr.vue?vue&type=template&id=2ef5d7f2&scoped=true&"
import script from "./ConversationsIvr.vue?vue&type=script&lang=js&"
export * from "./ConversationsIvr.vue?vue&type=script&lang=js&"
import style0 from "./ConversationsIvr.vue?vue&type=style&index=0&id=2ef5d7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5d7f2",
  null
  
)

export default component.exports